module.exports = __webpack_public_path__ + "static/img/14000215.53a5e9a4.png";